<template lang="html">

  <VqModal
    :name="modalName"
    class="vq-modal-add-pool">
    <template v-slot:header>
      <h2 class="modal-title">{{setTitleContext}} <span class="is-bold">{{ $t('components.modalEditUser.user') }}</span></h2>
      <div v-if="context=='update' && formData.status=='Locked'">
        <button
          v-if='display_edit'
          type="button"
          class="button is-xsmall is-alpha"
          v-on:click="unlockUser()">{{ $t('components.modalEditUser.unlock') }}</button>
      </div>

      <button
        type="button"
        class="button is-square is-rounded is-xsmall is-gray-100 modal-close"
        v-on:click="close">
        <span class="css-icon is-close"></span>
      </button>
    </template>

    <template v-slot:content>
      <div class="forms">
        <form>
          <div class="container has-separator">
            <VqRadio
              name="is_admin"
              :label="$t('components.modalEditUser.form.type')"
              :options="radioOptions"
              :default="radioDefault"
              :columns="2"
              :tooltip="c('add_users:is_admin')"
              :model.sync="radioData"/>
          </div>
          <div class="container has-separator">
            <div class="row">
              <div class="vq-repeater col-12">
                <div class="field-wrapper">
                  <template>
                    <div class="row">
                      <VqInput
                          classes="col-tab-6 mt-10"
                          :label="$t('components.modalEditUser.form.firstname')"
                          name="given_name"
                          type="text"
                          :errors="errors.given_name"
                          v-model="formData.given_name"
                      />
                      <VqInput
                          classes="col-tab-6 mt-10"
                          :label="$t('components.modalEditUser.form.lastname')"
                          name="last_name"
                          type="text"
                          :errors="errors.sn"
                          v-model="formData.sn"
                      />
                      <VqInput
                          classes="col-tab-6 mt-10"
                          :label="$t('components.modalEditUser.form.mail')"
                          name="mail"
                          type="mail"
                          :errors="errors.mail"
                          v-model="formData.mail"
                      />
                      <VqInput
                          classes="col-tab-6 mt-10"
                          :label="$t('components.modalEditUser.form.phone')"
                          name="last_name"
                          type="text"
                          :errors="errors.phone"
                          v-model="formData.phone"
                      />
                      <VqInput
                          classes="col-tab-6 mt-10"
                          :label="$t('components.modalEditUser.form.username')"
                          name="cn"
                          type="text"
                          :read-only="context=='update'"
                          :errors="errors.username"
                          v-model="username"
                      />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>

          <div v-if="!radioData.value" class="container has-separator">
            <VqCheckboxes
              :label="$t('components.modalEditUser.form.roles')"
              name="roles"
              :columns="2"
              :options="roles"
              v-model="formData.roles"/>
          </div>
        </form>
        <div v-if="errors.non_field_errors" class="container has-separator">
          <p v-for="error in errors.non_field_errors" :key="error" class="is-danger">{{error}}</p>
        </div>
      </div>
    </template>
    <template v-if="context=='update'" v-slot:footer>
      <button v-if='display_edit' type="button" class="button is-small is-danger is-outline" v-on:click="deleteUser">{{ $t('components.modalEditUser.form.delete') }}</button>
      <div>
        <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalEditUser.form.cancel') }}</button>
        <button
          v-if='display_edit'
          :class="{'is-loading': isFormLoading}"
          type="button"
          class="button is-small is-gamma"
          @click="createUser">{{setTitleContext}} {{ $t('components.modalEditUser.user') }}</button>
      </div>
    </template>
    <template v-else v-slot:footer>
      <button type="button" class="button is-small is-gray-400" v-on:click="close">{{ $t('components.modalEditUser.form.cancel') }}</button>
      <div>
        <button
          v-if='display_edit'
          :class="{'is-loading': isFormLoading}"
          type="button"
          class="button is-small is-gamma"
          @click="createUser">{{setTitleContext}} {{ $t('components.modalEditUser.user') }}</button>
      </div>
    </template>
  </VqModal>
</template>

<script lang="js">
import { eventHubMixin } from '@/mixins/event'

import USERS from '@/api/users'

import VqModal from '@/components/VqModal.vue'
import VqInput from '@/components/VqInput.vue'
import VqRadio from '@/components/VqRadio.vue'
import VqToggleBtn from '@/components/VqToggleBtn.vue'
import VqCheckboxes from '@/components/VqCheckboxes.vue'

export default {
  name: 'ModalAddEditUser',
  mixins: [eventHubMixin],
  components: {
    VqModal,
    VqInput,
    VqRadio,
    VqToggleBtn,
    VqCheckboxes
  },
  props: {
    roles: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      display_edit: true,
      radioDefault: 'No',
      radioOptions: [
        {
          label: this.$t('components.modalEditUser.config.radioOptions.admin'),
          value: true,
        },
        {
          label: this.$t('components.modalEditUser.config.radioOptions.standard'),
          value: false,
        },
      ],
      radioData: { value: true },
      modalName: 'add-edit-user',
      formData: {},
      errors: {},
      usernameIsSet: false,
      context: 'add',
      isFormLoading: false,
    }
  },
  computed: {
    setTitleContext() {
      if (this.context === 'add') {
        return this.$t('components.modalEditUser.config.add')
      }
      if (this.context === 'update') {
        return this.$t('components.modalEditUser.config.update')
      }
      return this.$t('components.modalEditUser.config.edit')
    },
    username: {
      set(val) {
        this.formData = {
          ...this.formData,
          ...{ username: val },
        }
        this.usernameIsSet = true
      },
      get() {
        if ([this.formData.given_name, this.formData.sn].some(el => el !== '') && !this.usernameIsSet) {
          return `${this.formData.given_name}.${this.formData.sn}`.toLowerCase()
        }
        return this.formData.username.toLowerCase()
      },
    },
  },
  mounted() {
    this.display_edit = this.$store.state.display_edit
    this.eventHub.$on(`modal:${this.modalName}:open`, (data) => {
      this.initFormData()
      this.initFormErrors()
      if (data) {
        this.context = 'update'
        this.usernameIsSet = true
        Object.assign(this.formData, data)
        if (this.formData.is_customer_admin) {
          this.radioData.value = true
        } else {
          this.radioData.value = false
        }
      } else {
        this.context = 'add'
      }
    })
  },
  methods: {

    close() {
      this.eventHub.$emit(`modal:${this.modalName}:close`)
    },

    initFormData() {
      this.formData = {
        given_name: '',
        sn: '',
        mail: '',
        phone: '',
        username: '',
        lockout_time: 0,
        is_admin: false,
        status: 'Disabled',
        roles: []
      }
      this.usernameIsSet = false
    },

    initFormErrors() {
      this.errors = {
        given_name: [],
        sn: [],
        mail: [],
        phone: [],
        username: [],
      }
    },
    unlockUser() {
      const username = { username: this.formData.username }
      USERS.unlock(username).then(
        () => {
          this.formData.status = 'Enabled'
          this.$emit('edituser', this.formData)
          this.emitToaster(this.$t('components.modalEditUser.toasts.unlock'), `${this.$t('components.modalEditUser.user')} ${username} ${this.$t('components.modalEditUser.toasts.unlockContent')}`, success)
          this.initFormData()
          this.initFormErrors()
          this.close()
        },
        (err) => {
          Object.assign(this.errors, err.response.data)
        },
      )
    },

    emitToaster(title, text, state) {
      this.emitAddToaster({
        title,
        text,
        state,
      })
    },

    checkData(data, emitMethod) {
      this.formData.is_customer_admin = this.radioData.value
      this.formData.is_customer_user = !this.radioData.value
      this.$emit(emitMethod, this.formData)
    },

    performSuccessAction(event) {
      this.isFormLoading = false
      this.formData.is_customer_admin = this.radioData.value
      this.formData.is_customer_user = !this.radioData.value

      this.formData.roles_name = []
      this.roles.forEach(role => {
        if (this.formData.roles.includes(role.id)) {
          this.formData.roles_name.push(role.name)
        }
      });
      this.$emit(event, this.formData)
      this.initFormData()
      this.initFormErrors()
      this.close()
    },

    createUser() {
      this.isFormLoading = true
      this.formData.is_admin = this.radioData.value
      this.formData.username = this.username
      if (this.context === 'add') {
        USERS.create(this.formData).then(
          (res) => {
            this.performSuccessAction('createuser')
            this.emitToaster(this.$t('components.modalEditUser.toasts.success'), `${this.$t('components.modalEditUser.user')} ${this.formData.username} ${this.$t('components.modalEditUser.toasts.edited')}`, 'success')
          },
          (err) => {
            if (err.response.data.errors) {
              this.emitToaster(this.$t('components.modalEditUser.toasts.createFailed'), `${this.$t('components.modalEditUser.user')} ${this.formData.username} ${this.$t('components.modalEditUser.toasts.createFailedContent')} ${err.response.data.errors}`, 'danger')
              this.close()
            }
            this.isFormLoading = false
            Object.assign(this.errors, err.response.data)
          },
        )
      } else {
        USERS.update(this.formData).then(
          (res) => {
            this.performSuccessAction('edituser')
            this.emitToaster(this.$t('components.modalEditUser.toasts.success'), `${this.$t('components.modalEditUser.user')} ${this.formData.username} ${this.$t('components.modalEditUser.toasts.edited')}`, 'success')
          },
          (err) => {
            if (err.response.data.errors) {
              this.emitToaster(this.$t('components.modalEditUser.toasts.editFailed'), `${this.$t('components.modalEditUser.user')} ${this.formData.username} ${this.$t('components.modalEditUser.toasts.editGroupFailedContent')} ${err.response.data.errors}`, 'danger')
              this.close()
            }
            this.isFormLoading = false
            Object.assign(this.errors, err.response.data)
          },
        )
      }
    },

    deleteUser() {
      this.eventHub.$emit('modal:delete-user:open', this.formData)
      this.close()
    },
  },
}
</script>

<style scoped lang="scss">

</style>
